export default __webpack_public_path__ + "static/GothamBook-d946fc4006181ac4e1c7ae7947220c46.otf";